import { GravyBinder } from "gravy-bind";
import { formHasValue } from "./utils/form-has-value";
import { IErrorValidator } from "./error-validator.interface";
import reportValidity from 'report-validity';
import Inputmask from "inputmask/dist/inputmask";
import { loopThroughElements } from "./utils/loop-through-elements";
import { touchAllInputs } from "./utils/touch-all-inputs";

export class ReachAgent implements IErrorValidator {
    public static htmlId = 'reach-an-agent';

    public rootElement: HTMLFormElement;
    public responseMethod: string;
    public contactMethod: string;
    public recaptcha: string;
    public topicType: string;
    private submitAttempted = false;
    private binder: GravyBinder;

    constructor(element: HTMLElement) {
        this.rootElement = element as HTMLFormElement;
        this.initialize();
    }

    private initialize = (): void => {
        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateBindings();
        this.rootElement.addEventListener('submit', this.onSubmit);
        loopThroughElements(this.rootElement.querySelectorAll('input[type=tel]'), el => Inputmask('999-999-9999').mask(el));
    }

    public highlightError = (formInputName: string): boolean => {
        if (!this.submitAttempted)
            return false;
        return formHasValue(this.rootElement, formInputName);
    }


    private onSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitAttempted = true;
        this.binder.updateOutwardBindings();
        touchAllInputs(this.rootElement);
        reportValidity(this.rootElement);

        // runs default behaviour (submitting) in case of validation success
        if (this.rootElement.checkValidity())
            this.rootElement.submit();
    }
    public unhideField = (): boolean => this.contactMethod === 'Phone' || this.contactMethod === 'Email';
}